import { AdminStripeAllOrdersScreenPath } from "../Stripe/AdminStripeAllOrdersScreen.tsx";
import { AdminHeyLightAllOrdersScreenPath } from "../HeyLight/AdminHeyLightAllOrdersScreen.tsx";
import { BONIFICO_ORDERS_LIST_PATH } from "../BonificoOrder/bonificoOrdersListPath.ts";
import { SalesGateway } from "./SaleRecord.ts";
import { SalesPeriod } from "./salesPeriod.ts";

const ORDERS_LIST_PATHS: Record<SalesGateway, string> = {
  [SalesGateway.Stripe]: AdminStripeAllOrdersScreenPath,
  [SalesGateway.HeyLight]: AdminHeyLightAllOrdersScreenPath,
  [SalesGateway.Bonifico]: BONIFICO_ORDERS_LIST_PATH,
};

const CALENDAR_DATE_FORMAT = "YYYY-MM-DD";

export function ordersListPathFor({
  gateway,
  period,
  itemKey,
  statuses,
}: {
  gateway: SalesGateway;
  period?: SalesPeriod;
  itemKey?: string;
  statuses?: string[];
}): string {
  const params = new URLSearchParams();
  if (statuses?.length) params.set("status", statuses.join(","));
  if (itemKey) params.set("product", itemKey);
  if (period) {
    params.set("createdFrom", period.from.format(CALENDAR_DATE_FORMAT));
    params.set("createdTo", period.to.format(CALENDAR_DATE_FORMAT));
  }
  const query = params.toString();
  return query
    ? `${ORDERS_LIST_PATHS[gateway]}?${query}`
    : ORDERS_LIST_PATHS[gateway];
}
